import { createContext } from "react"

export const defaultCt = {
  map: null as any
}
export const MapContext = createContext(defaultCt)
